export default __webpack_public_path__ + "static/media/group.1cfe242b.jpeg";